import React from 'react'
import {
  type ResetPasswordForm, type ResetPasswordPayload
} from '../../../api/schema-dtos/AuthPayloadDtos'
import { validateResetPasswordPayload } from '../../../api/schema-dtos/AuthDomainDtos'
import { Button, Grid, Paper, TextField, Typography } from '@mui/material'
import ErrorComponent from '../../shared/components/ui-widgets/ErrorComponent'
import { Formik } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import { useResetPasswordMutation } from '../../../api/user/authenticationApi'
import { setNotification } from '../../shared/components/ui-widgets/uiWidgetsSlice'
import { RtkQueryHelper } from '../../../api/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../app/hooks'
import ButtonLoadingComponent from '../../shared/components/ui-widgets/ButtonLoadingComponent'

const ResetPasswordComponent: React.FC = () => {
  const params = useParams()
  const resetCode: string = (params as any).resetCode

  const defaultForm: ResetPasswordForm = {
    password: '',
    username: '',
    confirmationPassword: ''
  }

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [apiResetPassword, resetPasswordApiResult] = useResetPasswordMutation()

  const handleResetPassword = (formData: ResetPasswordForm): void => {
    const payload: ResetPasswordPayload = {
      resetCode,
      password: formData.password,
      username: formData.username
    }

    apiResetPassword(payload)
      .unwrap()
      .then(() => {
        navigate('/auth/login')
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  return (
    <>
      <Paper sx={{ p: 4 }}>

        <Typography variant={'body1'} sx={{ mb: 3 }}>Please enter your email address and then enter and confirm a new password to complete the password reset.</Typography>

        <Formik
          initialValues={defaultForm}
          validationSchema={validateResetPasswordPayload}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={async (values, actions) => {
            handleResetPassword(values)
          }}
        >
          {formikProps => (
            <form
              autoComplete={'off'}
              autoCorrect={'off'}
              onSubmit={formikProps.handleSubmit}
            >
              <Grid container spacing={2}>
                {!(formikProps.isValid) && (
                  <Grid item md={12} sx={{ mt: 3 }}>
                    <ErrorComponent title={'Form validation error'} message={Object.values(formikProps.errors).join(', ')}/>
                  </Grid>
                )}
                <Grid item md={12} xs={12}>
                  <TextField
                    label={'Email Address'}
                    type={'email'}
                    variant="outlined"
                    sx={{ width: '100%' }}
                    placeholder={'Email Address'}
                    {...formikProps.getFieldProps('username')}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    label={'Password'}
                    type={'password'}
                    variant="outlined"
                    sx={{ width: '100%' }}
                    placeholder={'Password'}

                    {...formikProps.getFieldProps('password')}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <TextField
                    label={'Confirmation Password'}
                    type={'password'}
                    variant="outlined"
                    sx={{ width: '100%' }}
                    placeholder={'Password'}

                    {...formikProps.getFieldProps('confirmationPassword')}
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Button
                    variant={'contained'}
                    type="submit"
                    sx={{ mr: 2 }}
                    disabled={resetPasswordApiResult.isLoading}>
                    Reset Password
                    {(resetPasswordApiResult.isLoading && <ButtonLoadingComponent/>)}
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Paper>
    </>
  )
}

export default ResetPasswordComponent
